
export const environment = {
  production: true,
  apiURL: 'https://infokaw.com.br/api',
  siteKey: '6Lc48LYZAAAAAJk7qXiBpsfwgvVZUCghv7Ty9XoG',
  turnstileSiteKey: '0x4AAAAAABfFusTp47FQfJPP',
  turnstileEnabled: true,
  mercadoPagoPublicKey: 'APP_USR-fde55cd8-3f63-4fd0-a3b5-90611ff640bb',
  mqtt: {
		server: 'infokaw.com.br',
		protocol: "wss",
		port: 8883,
    useSSL: true,
    path: "/mqtt",
    clientId: "SUPERVISORIO-HTTPS",
    username: 'api',
    password: '@9a03b933a5'
	}
};